<div class="flex flex-row {{containerClass}} profile-flagsX"
    [ngClass]="{'w-full' : columnWidth == 'fill'}"
    [ngStyle]="{ 'justify-content': columnWidth === 'fill' ? 'space-evenly' : 'flex-start' }"
    style="justify-content: space-evenly;">
    @for(df of dynamicFormConfigs; let i = $index; track i)
    {
        <ui-form
            [config]="df"
            [formValues]="dynamicFormValues[i]"
            [asColumn]="true"
            class="{{columnClass}}"
            (checkboxChange)="onCheckboxChange($event)"
        ></ui-form>
    }
</div>

